import React, { useState } from 'react';
import { ChevronDown, Folder, FolderOpen } from 'lucide-react';
import { dataItaliana } from './archivioApi';
import { AzioniScansione, StatoScansione } from './ScansioneControlli';

const RigaDDT = ({ ddt, onAggiorna }) => {
  const numero = ddt.numero_ddt_fornitore ? String(ddt.numero_ddt_fornitore).replace(/^n\.?\s*/i, '') : null;
  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center gap-x-3 gap-y-2 px-4 py-3" data-testid={`archivio-ddt-${ddt.id}`}>
      <div className="min-w-0 basis-full sm:basis-auto sm:flex-1">
        <p className="text-sm font-semibold text-white lg:text-gray-900 break-words" data-testid={`archivio-ddt-data-${ddt.id}`}>
          {dataItaliana(ddt.data_ddt_iso) || <span className="italic text-amber-300 lg:text-amber-600">Data non indicata</span>}
          <span className="ml-2 font-normal text-slate-300 lg:text-gray-600 break-all">DDT n. {numero || '—'}</span>
        </p>
        <p className="text-xs text-slate-500 lg:text-gray-400">Registrazione interna #{ddt.numero}</p>
      </div>
      <StatoScansione ddt={ddt} />
      <AzioniScansione ddt={ddt} onAggiorna={onAggiorna} />
    </div>
  );
};

export const FornitoreArchivio = ({ fornitore, indice, forzaAperto, onAggiorna }) => {
  const [aperto, setAperto] = useState(false);
  const visibile = aperto || forzaAperto;
  const altri = fornitore.varianti_nome.filter((n) => n !== fornitore.nome);
  const Icona = visibile ? FolderOpen : Folder;
  return (
    <div className="rounded-2xl border border-slate-700/60 bg-slate-800/60 lg:bg-white lg:border-gray-200 overflow-hidden"
      data-testid={`archivio-fornitore-${indice}`}>
      <button type="button" onClick={() => setAperto(!visibile)} data-testid={`archivio-fornitore-toggle-${indice}`}
        className="w-full flex items-center gap-3 p-4 text-left hover:bg-white/5 lg:hover:bg-gray-50 transition-colors">
        <span className="w-10 h-10 rounded-xl bg-purple-500/20 lg:bg-purple-50 flex items-center justify-center shrink-0">
          <Icona className="h-5 w-5 text-purple-300 lg:text-purple-600" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block font-semibold text-white lg:text-gray-900 truncate" data-testid={`archivio-fornitore-nome-${indice}`}>
            {fornitore.nome}
          </span>
          <span className="block text-xs text-slate-400 lg:text-gray-500">
            {fornitore.ddt.length} DDT
            {fornitore.n_mancanti > 0 && (
              <span className="sm:hidden text-amber-300 font-semibold" data-testid={`archivio-fornitore-mancanti-mobile-${indice}`}>
                {' '}· {fornitore.n_mancanti} senza scansione
              </span>
            )}
          </span>
          {altri.length > 0 && (
            <span className="block text-[11px] text-slate-500 lg:text-gray-400 truncate" title={altri.join(', ')}>
              scritto anche: {altri.join(', ')}
            </span>
          )}
        </span>
        {fornitore.n_mancanti > 0 && (
          <span className="hidden sm:inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold bg-amber-500/15 text-amber-300 lg:bg-amber-50 lg:text-amber-700 whitespace-nowrap"
            data-testid={`archivio-fornitore-mancanti-${indice}`}>
            {fornitore.n_mancanti} senza scansione
          </span>
        )}
        <ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 lg:text-gray-400 transition-transform ${visibile ? 'rotate-180' : ''}`} />
      </button>
      {visibile && (
        <div className="border-t border-slate-700/60 lg:border-gray-100 divide-y divide-slate-700/60 lg:divide-gray-100">
          {fornitore.ddt.map((d) => <RigaDDT key={d.id} ddt={d} onAggiorna={onAggiorna} />)}
        </div>
      )}
    </div>
  );
};
